<div class="search-results" [style.max-height]="maxHeight + 'px'" #results>
    @for (item of list; track item) {
        <div kui-action class="p-2 search-results__item" [class.active]="item.active" (click)="selectResult(item)">
            @if (item.icon) {
                <kui-icon [name]="item.icon" size="sm" class="mr-3 muted-more"></kui-icon>
            }
            <span [innerHTML]="highlightTerm(item.value)"></span>
        </div>
    }
</div>
